
export const getFeatureFlag = async (featureFlagName: string): Promise<boolean> => {
  const { data, error } = await useApi(`FeatureFlag?featureFlagName=${featureFlagName}`);
  if (error) {
    console.error(`Error fetching feature flag ${featureFlagName}:`, error);
    return false;
  }
  return data;
};